import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`South Sudan`}</h3>
    <p>{`In 2019, food insecurity reached its most extreme levels since South Sudan’s independence in 2011. In June, a record number of people – nearly 7 million, or more than 60 percent of the entire population – struggled to put food on their plate. The EU’s support was crucial in making sure the most vulnerable people in the country were not left behind. It is thanks to such committed donors that WFP reached nearly `}<a parentName="p" {...{
        "href": "https://www.wfp.org/emergencies/south-sudan-emergency"
      }}>{`5 million`}</a>{` people with life-saving cash and in-kind food assistance.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      